import { getPage } from "../content";
import { DocLink } from "./DocLink";
import type { SiteState } from "../app/site-state";
export function Header(props: { site: SiteState }) {
  const site = props.site;
  const { router, menu, searching } = site;
  return (
    <header class="header" id="top">
      <router.Link class="brand" href="/" onClick={() => { menu.value = false; }}>
        <span class="brand-mark" aria-hidden="true">
          Z
        </span>
        zyra
        <span class="brand-slash" aria-hidden="true">
          /
        </span>
        <span class="brand-docs">docs</span>
      </router.Link>
      <button
        class="search-trigger"
        onClick={() => {
          searching.value = true;
        }}
      >
        <span>⌕</span>Search documentation<kbd>Ctrl K</kbd>
      </button>
      <div class="header-right">
        <span class="version">
          v0.1 <i />
        </span>
        <DocLink
          site={site}
          class="header-start"
          page={getPage("installation")}
        >
          Get started ↗
        </DocLink>
        <button
          class="menu-toggle"
          aria-label="Toggle navigation"
          aria-expanded={menu.value}
          aria-controls="sidebar"
          onClick={() => {
            menu.value = !menu.value;
          }}
        >
          ☰
        </button>
      </div>
    </header>
  );
}
